import { Spinner, type SpinnerProps } from '@chakra-ui/react' 
import React from 'react'


const Component = React.forwardRef((props: SpinnerProps, ref: React.Ref<any>) => {
  return (
    <Spinner ref={ref} speed='0.65s' { ...props } />
  )
})


export {
  Component as Spinner,
  type SpinnerProps,
}